const tinyMceFunctions = require('./jsinc/_replace_tinymce_content');

function dzsvg_receiver(arg) {
  var aux = '';
  var bigaux = '';
  //console.log(arg);
  if (window.console) {
    console.info(arg);
  }
  ;


  tinyMceFunctions.tinyMceContentReplace(arg);

  //console.log(bigaux);
  close_ultibox();
}

window.close_zoombox = function () {
  jQuery.fn.zoomBox.close();

}
window.dzsvg_receiver = dzsvg_receiver;

function close_zoombox2() {
  window.close_ultibox();
}